var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.432,
    height: 15.432,
    viewBox: "0 0 15.432 15.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M14.33,8.313H9.37V3.352a1.1,1.1,0,0,0-1.1-1.1h-1.1a1.1,1.1,0,0,0-1.1,1.1v4.96H1.1A1.1,1.1,0,0,0,0,9.415v1.1a1.1,1.1,0,0,0,1.1,1.1h4.96v4.96a1.1,1.1,0,0,0,1.1,1.1h1.1a1.1,1.1,0,0,0,1.1-1.1V11.62h4.96a1.1,1.1,0,0,0,1.1-1.1v-1.1A1.1,1.1,0,0,0,14.33,8.313Z",
    transform: "translate(0 -2.25)",
    fill: "#40eefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEPlus);
export default __webpack_public_path__ + "static/media/e-plus.ed8cec756904a50d2356965071091c60.svg";
export { ForwardRef as ReactComponent };